import moment from "moment";
import MyBsSelect from "src/components/common/FormElements/MyBsSelect";
import { useRegularClassScheduleQuery } from "src/services/react-query-apis/get-regular-class-schedules";
import generateOptions from "src/utils/generateOptions";

const TimeRow = ({ pos, disabled, formData, handleTimeChange }) => {
  const key = `class_level_${pos}`;
  const day = formData[`day_week_${pos}`];
  const processedDate = formData.processed_date;

  const regularClassScheduleQuery = useRegularClassScheduleQuery({
    id: formData.regular_class_id,
    day_week: day,
    rank: formData.class,
    withInvalidated: 1,
    month: processedDate,
    queryConfig: {
      enabled: !!(formData.regular_class_id && day),
    },
  });

  const options = [{ value: "no-value", label: "時間を選択してください" }];

  if (regularClassScheduleQuery.isSuccess) {
    const schedules = regularClassScheduleQuery.data.data;

    schedules.forEach(schedule => {
      const timeOptionString = schedule.option_string;

      options.push({
        value: schedule.id,
        label: timeOptionString,
      });
    });
  }

  return (
    <MyBsSelect
      label=""
      key={key}
      name={key}
      value={formData[key]}
      onChange={handleTimeChange}
      placeholder=""
      disabled={disabled}
      readOnly={false}
    >
      {generateOptions(options)}
    </MyBsSelect>
  );
};

export default TimeRow;
